// API Configuration
const API_URL = import.meta.env.VITE_API_URL || '';

// Helper function to build API URLs
export const buildApiUrl = (path: string): string => {
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // If API_URL is set, use it as the base
  if (API_URL) {
    // Remove trailing slash from API_URL if present
    const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    return `${baseUrl}/${cleanPath}`;
  }
  
  // Fallback to relative path (for local development with proxy)
  return `/${cleanPath}`;
};

export default { API_URL, buildApiUrl };
